import axios from "axios";
import { Get, Post } from "../server";

// 查看银行卡充值配置
export function getRechargeSetting() {
  return Get("/admin/charge/bankCard/conf");
}

export function getBankList(params: any) {
  // return Get("/admin/system/banks");
  return Get("/admin/user/draws", params);
}

// 修改银行卡充值配置
export function updateRechargeSetting(data: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/charge/bankCard/conf`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

//  查看银行卡充值渠道列表
export function createRechargeLine(data: any) {
  return axios({
    url: `/admin/charge/channel/bankCard/channel`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 查看银行卡充值渠道列表
export function getRechargeChannels(params: any) {
  return Get("/admin/charge/channel/bankCard/channels", params);
}

// 查看银行卡充值渠道QR码
export function getQRCode(filename: string) {
  const url = filename.replace("/admin", "");
  return Get(url);
}

// 修改银行卡充值渠道
export function updateRechargeLine(channelId: string, data: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/charge/channel/bankCard/channel/${channelId}`,
    method: "put",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 新增银行
export function addBank(data: any) {
  return axios({
    url: `/admin/system/bank`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}
// 修改银行卡
export function updateBank(bankId: string, data: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/system/bank/${bankId}`,
    method: "put",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 查看银行卡充值常用金额列表
export function getRechargeMoney() {
  return Get("/admin/charge/conf/amountList");
}

// 修改银行卡
export function updateRechargeMoney(data: any) {
  //Get方法用于向后台发送请求
  return axios({
    url: `/admin/charge/conf/amountList`,
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("come-to-chant-token"),
    },
    data,
    baseURL: process.env.REACT_APP_BASE_URL,
  });
}

// 查看银行卡充值常用金额列表
export function getRechargeRecord(data: any) {
  return Get("/admin/charge/charge/charges", data);
}

export function getauditList(data: any) {
  return Get("/admin/withdrawCash/audit/withdrawCashes", data);
}

// 提现客服审核银行卡提现申请
export function changeBankCardInform(data: any) {
  return Post("/admin/withdrawCash/audit/bankCard", data)
}
// 财务客服银行卡提现打款
export function changeRemitCardInfotm(data: any) {
  return Post("/admin/withdrawCash/remit/bankCard", data)
}

export function getremitList(data: any) {
  return Get("/admin/withdrawCash/remit/withdrawCashes", data);
}

// 查询到账
export const surePayedFor = (data: any) => {
  return Post("/admin/charge/charge/bankCard/orderComplete", data)
}

// 关闭充值订单
export const notPayedFor = (data: any) => {
  return Post("/admin/charge/charge/bankCard/close", data)
}